import { rewards } from '../../../api';
import { call, takeLatest, put, delay } from 'redux-saga/effects';
import {
  GET_AGENCY_REWARD_DETAILS,
  GET_AGENCY_REWARD_DETAILS_START,
  GET_AGENCY_REWARD_DETAILS_COMPLETE,
  GET_AGENCY_REWARD_DETAILS_ERROR,
  UPDATE_AGENCY_REWARD_DETAILS,
  UPDATE_AGENCY_REWARD_DETAILS_START,
  UPDATE_AGENCY_REWARD_DETAILS_COMPLETE,
  UPDATE_AGENCY_REWARD_DETAILS_ERROR,
  GET_ESTIMATED_MONTHLY_COST,
  GET_ESTIMATED_MONTHLY_COST_START,
  GET_ESTIMATED_MONTHLY_COST_COMPLETE,
  GET_ESTIMATED_MONTHLY_COST_ERROR,
} from './actions';
import errorStrings from '../../../constants/errorStrings';
import { setUserStatusUnauthorised } from '../userProfile/actions';

export function* getAgencyRewardDetails({}) {
  try {
    yield put({
      type: GET_AGENCY_REWARD_DETAILS_START,
    });
    const { response, error } = yield call(rewards.getAgencyRewardDetails);

    if (!!response) {
      yield put({
        type: GET_AGENCY_REWARD_DETAILS_COMPLETE,
        payload: { data: response },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetAgencyRewardDetailsError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetAgencyRewardDetailsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* updateAgencyRewardDetails({ payload: { params, successCallback } }) {
  try {
    yield put({
      type: UPDATE_AGENCY_REWARD_DETAILS_START,
    });
    const { response, error } = yield call(rewards.updateAgencyRewardDetails, {
      params,
    });
  
    // yield delay(3000);
    // const response = 'success';
    // const error = '';
    if (!!response) {
      yield put({
        type: UPDATE_AGENCY_REWARD_DETAILS_COMPLETE,
      });
      yield call(successCallback);
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onUpdateAgencyRewardDetailsError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onUpdateAgencyRewardDetailsError({
        error: errorStrings.commonError,
      }),
    );
  }
}

export function* getEstimatedMonthlyCost({}) {
  try {
    yield put({
      type: GET_ESTIMATED_MONTHLY_COST_START,
    });
    const { response, error } = yield call(rewards.getEstimatedMonthlyCost);

    if (!!response) {
      yield put({
        type: GET_ESTIMATED_MONTHLY_COST_COMPLETE,
        payload: { data: response.estimatedMonthlyCost },
      });
    } else {
      //call logout
      if (error.status === 401) {
        yield put(setUserStatusUnauthorised());
      } else {
        //Show error boundary if error is 500 or other
        yield put(
          onGetEstimatedMonthlyCostError({
            error: error?.data.message ? error?.data.message : errorStrings.commonError,
          }),
        );
      }
    }
  } catch (error) {
    yield put(
      onGetEstimatedMonthlyCostError({
        error: errorStrings.commonError,
      }),
    );
  }
}

const onGetEstimatedMonthlyCostError = (payload = {}) => ({
  type: GET_ESTIMATED_MONTHLY_COST_ERROR,
  payload,
});

const onUpdateAgencyRewardDetailsError = (payload = {}) => ({
  type: UPDATE_AGENCY_REWARD_DETAILS_ERROR,
  payload,
});

const onGetAgencyRewardDetailsError = (payload = {}) => ({
  type: GET_AGENCY_REWARD_DETAILS_ERROR,
  payload,
});

function* watchGetEstimatedMonthlyCost() {
  yield takeLatest(GET_ESTIMATED_MONTHLY_COST, getEstimatedMonthlyCost);
}

function* watchUpdateAgencyRewardDetails() {
  yield takeLatest(UPDATE_AGENCY_REWARD_DETAILS, updateAgencyRewardDetails);
}

function* watchGetAgencyRewardDetails() {
  yield takeLatest(GET_AGENCY_REWARD_DETAILS, getAgencyRewardDetails);
}

export const sagas = [
  watchGetAgencyRewardDetails,
  watchUpdateAgencyRewardDetails,
  watchGetEstimatedMonthlyCost,
];
